import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Destinations from "./pages/Destinations";
import Experiences from "./pages/Experiences";
import PlanJourney from "./pages/PlanJourney";
import About from "./pages/About";
import installBadgeRemover from "./lib/removeBadge";

// Run once at module load to catch the badge as early as possible.
installBadgeRemover();

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App bg-ink min-h-screen text-bone">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/destinations" element={<Destinations />} />
          <Route path="/experiences" element={<Experiences />} />
          <Route path="/plan" element={<PlanJourney />} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <Toaster
          theme="dark"
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#0F0F0F",
              color: "#F7F3EA",
              border: "1px solid rgba(197,160,89,0.3)",
              borderRadius: 0,
              fontFamily: "Outfit, sans-serif",
              letterSpacing: "0.04em",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
